const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const EmailAndSmsServiceLogsQuery: any = {
    GetMailLogByReceiver: Backofficebff + '/v1/notification/GetMailLogByReceiver',
    GetSmsLogByPhone: Backofficebff + '/v1/notification/GetSmsLogByPhone',
};
